const ICON_URL = "https://customer-assets.emergentagent.com/job_mahlo-journeys/artifacts/8jn14j5h_logo%20sem%20escrita.png";

const Logo = ({ iconHeight = 42, showText = true }) => (
  <div className="flex items-center gap-2.5">
    <img
      src={ICON_URL}
      alt="Mahlo Viagens"
      style={{ height: `${iconHeight}px`, width: 'auto', mixBlendMode: 'screen' }}
      className="object-contain flex-shrink-0"
    />
    {showText && (
      <div className="flex flex-col leading-none select-none">
        <span className="font-bold tracking-widest text-white text-base" style={{ fontFamily: 'Manrope, sans-serif' }}>
          MAHLO
        </span>
        <span className="font-light tracking-wider text-[#89A6A3] text-sm" style={{ fontFamily: 'Manrope, sans-serif' }}>
          VIAGENS
        </span>
      </div>
    )}
  </div>
);

export default Logo;
